import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { OuterWrapper, InnerWrapper, CloseIcon, CloseIconWrapper } from './TooltipContent.styles';

const TooltipPortal = ({ children }: React.PropsWithChildren<unknown>) => {
  const tooltipRoot = document.body;
  const el = document.createElement('div');

  useEffect(() => {
    tooltipRoot.appendChild(el);

    return () => {
      try {
        tooltipRoot.removeChild(el);
      } catch (e) {
        // node was already removed
      }
    };
  }, []);

  return createPortal(children, el);
};

type OwnProps = React.PropsWithChildren<{
  arrowPosition?: string;
  className?: string;
  closeTooltip?: (...args: unknown[]) => void;
  closeTooltipOnX?: () => void;
  contentWidth?: number;
  direction?: string;
  offsetTooltip?: Record<string, unknown>;
  position?: Record<string, unknown>;
  show?: boolean;
}>;

const noop = (..._args: unknown[]) => {};

export default function TooltipContent({
  arrowPosition = 'right',
  children,
  className = '',
  closeTooltip = noop,
  closeTooltipOnX,
  contentWidth = 250,
  direction = 'up',
  offsetTooltip = {},
  position = { rect: {}, scrollTop: 0, scrollLeft: 0 },
  show = false
}: OwnProps) {
  return (
    show && (
      <TooltipPortal>
        <OuterWrapper
          contentWidth={contentWidth}
          direction={direction}
          arrowPosition={arrowPosition}
          position={position}
          offsetTooltip={offsetTooltip}
          onClick={(e: React.MouseEvent) => closeTooltip(e, true)}
        >
          <InnerWrapper direction={direction} arrowPosition={arrowPosition} className={className}>
            <CloseIconWrapper onClick={() => closeTooltipOnX?.()}>
              <CloseIcon width={13} height={13} />
            </CloseIconWrapper>
            {children}
          </InnerWrapper>
        </OuterWrapper>
      </TooltipPortal>
    )
  );
}
